import React from 'react';
import StudentsNavbar from '../../Components/Navbars/StudentsNavbar';
import { Vacancies } from './Vacancies';
import { UserRole } from '../../Enums/UserRole';

export const StudentVacancies = () => {
    return (
        <>
            <StudentsNavbar />
            <Vacancies role={UserRole.Student}/>
        </>
    );
};